import React, { useEffect } from "react";
import CustomSelect from "../../../reusableComponents/CustomSelect/CustomSelect";
import { Button, Checkbox, TextField, Typography } from "@mui/material";
import { Close, ControlPoint } from "@mui/icons-material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { colorBrandObject } from "../../../../constants/brandings";

const initialState = { pspCode: "", percentage: "" };

const ProcessorList = ({
  processors,
  setSplitEqually,
  splitEqually,
  processorDynamicFields,
  setError,
  error,
}) => {
  const { fields, addField, removeField, updateField, setFields, resetFields } =
    processorDynamicFields;


  const handleShowError = (index, value) => {
    const totalPercentage =
      fields?.reduce((sum, item) => sum + (item.percentage * 1 || 0), 0) || 0;
    if (
      fields?.length === processors?.length &&
      fields[fields.length - 1]?.percentage
    ) {
      if (totalPercentage < 100) {
        setError("Sum of percentages should be 100% to activate the rule");
        return;
      }
    }
    if (fields?.length > 1 && totalPercentage > 100) {
      setError("Sum of percentages should be 100% to activate the rule");
      return;
    }
    setError("");
    if (!value) updateField(index, "error", "percentage is required");
    else if (value > 100) {
      updateField(index, "error", "percentage cannot be greater than 100%");
    } else if (value < 1) {
      updateField(index, "error", "percentage cannot be less than 1%");
    } else {
      updateField(index, "error", "");
    }
  };
  const handleFormattedOptions = () => {
    const selectedProcessors = fields.map((el) => el.pspCode);
    return processors.map((el) => {
      if (el?.value && selectedProcessors.includes(el.value)) {
        return { ...el, disabled: true };
      }
      return el;
    });
  };
  function splitValue(total, parts) {
    if (parts <= 0) return [];

    const baseValue = Math.floor(total / parts);
    const remainder = total % parts;
    const result = Array(parts).fill(baseValue);
    for (let i = 0; i < remainder; i++) {
      result[i] += 1;
    }

    return result;
  }
  const handleSplitPercentage = () => {
    const result = splitValue(100, fields?.length);
    setSplitEqually(true);
    if (result?.length) {
      setFields((state) => {
        return state.map((el, index) => ({
          ...el,
          percentage: result[index],
          error: "",
        }));
      });
      setError("");
    }
  };
  useEffect(() => {
    const hasSingleProcessor = processors?.length === 1;
    const hasSingleField = fields?.length === 1;
    const processor = hasSingleProcessor ? processors[0] : null;
    const field = hasSingleField ? fields[0] : null;

    if (hasSingleProcessor && hasSingleField) {
      if (!processor?.percentage && !field?.percentage) {
        updateField(0, "percentage", 100);
      }
      if (!processor?.pspCode && !field?.pspCode) {
        updateField(0, "pspCode", processor?.value);
      }
    }
  }, []);
  return (
    <>
      {fields?.length > 0 &&
        fields?.map((field, index) => (
          <>
            <div
              className="d-flex align-items-start my-2"
              style={{ gap: "20px", minHeight: "60px" }}
              key={`Processor-${index}`}
            >
              <div style={{ maxWidth: "250px", width: "20%", minWidth: "180px" }}>
                <Typography className="labelRegular mb-2">
                  Select a processor
                </Typography>
                <CustomSelect
                  placeholder="Select a processor"
                  options={handleFormattedOptions() || []}
                  value={field.pspCode}
                  onChange={(value) => {
                    updateField(index, "pspCode", value);
                  }}
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ maxWidth: "250px", width: "20%", minWidth: "180px" }}>
                <Typography className="labelRegular mb-2">
                  Percentage%
                </Typography>

                <TextField
                  type="number"
                  inputProps={{
                    min: 0,
                    max: 100,
                  }}
                  disabled={processors?.length == 1}
                  value={field.percentage}
                  onChange={(e) => {
                    updateField(index, "percentage", e.target.value);
                    setSplitEqually(false);
                  }}
                  fullWidth
                  onBlur={(e) => handleShowError(index, e?.target?.value)}
                  error={field.error || error}
                  name="percentage"
                  placeholder={"Enter distribution %"}
                  style={{ width: "100%" }}
                />
                {(field.error || error) && (
                  <div className="percentage-error-routing">
                    <ErrorOutlineIcon />
                    <Typography>{field.error || error}</Typography>
                  </div>
                )}
              </div>
              {fields?.length > 1 && (
                <span
                  className="clearRuleIcons"
                  style={{ marginTop: "25px" }}
                  onClick={() => {
                    setSplitEqually(false);
                    removeField(index);
                  }}
                >
                  <Close style={{ height: 16, width: 16, color: "#7F7D83" }} />
                </span>
              )}
            </div>
          </>
        ))}
      <div className="d-flex align-items-center" style={{ gap: 20 }}>
        {fields?.length < processors.length && (
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px", cursor: "pointer" }}
          >
            <ControlPoint sx={{ color: "#403E9F", fontSize: "16px" }} />
            <span
              style={{ color: "#403E9F", fontSize: "14px" }}
              onClick={() => {
                addField(initialState);
              }}
            >
              {" "}
              Add More Processor
            </span>
          </div>
        )}
        {fields?.length > 1 && (
          <Button className="splitEquallyBtn" onClick={handleSplitPercentage}>
            <Checkbox
              sx={{
                "& .MuiSvgIcon-root": {
                  color: colorBrandObject?.primary,
                },
                "&.Mui-checked": {
                  color: colorBrandObject?.primary,
                  "& .MuiSvgIcon-root": {
                    fill: colorBrandObject?.primary,
                  },
                },
              }}
              style={{ marginRight: 8 }}
              checked={splitEqually}
            />
            <span>Split Equally</span>
          </Button>
        )}
      </div>
    </>
  );
};

export default ProcessorList;
